export default __webpack_public_path__ + "static/media/logo.a39eefa5.png";